import { Skeleton } from 'antd';

type WidgetSkeletonProps = {
    title?: string;
    rows?: number;
    avatarSize?: { width: number; height: number };
};

export function WidgetSkeleton({
    title,
    rows = 5,
    avatarSize = { width: 32, height: 24 },
}: WidgetSkeletonProps) {
    return (
        <div className="bg-white p-4 rounded-md shadow-sm space-y-2">
            {title && (
                <h3 className="mb-5 text-base font-semibold text-deep-navy">
                    {title}
                </h3>
            )}
            {Array.from({ length: rows }).map((_, index) => (
                <div key={index} className="flex items-center gap-2">
                    <Skeleton.Avatar
                        shape="square"
                        size="small"
                        active
                        style={{
                            width: avatarSize.width,
                            height: avatarSize.height,
                        }}
                    />

                    <div className="flex-1 flex flex-col">
                        <Skeleton.Input
                            style={{ width: '50%', height: 8 }}
                            active
                            size="small"
                        />
                        <Skeleton.Input
                            style={{ width: '100%', height: 10 }}
                            active
                            size="small"
                        />
                    </div>
                </div>
            ))}
        </div>
    );
}
